document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll(
    '[data-section-type="equip-reasons-section"] .equip-reasons-section__container'
  );

  sections.forEach(container => {
    const section = container.closest(
      '[data-section-type="equip-reasons-section"]'
    );

    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const swiperEl = container.querySelector('.equip-reasons-swiper');
    const totalSlides = Number(section.dataset.totalSlides);

    if (!swiperEl || !totalSlides) return;

    const sectionRoot = `#shopify-section-${sectionId}`;

    const isAutoWidth = totalSlides >= 3;

    const updateCounter = swiper => {
      const slidesPerView =
        typeof swiper.params.slidesPerView === 'number'
          ? swiper.params.slidesPerView
          : Math.max(1, Math.round(swiper.slidesPerViewDynamic()));

      const visibleSlides = Math.floor(slidesPerView);

      const current = Math.min(swiper.realIndex + visibleSlides, totalSlides);

      const label = `${current} / ${totalSlides}`;

      container.querySelectorAll('[data-counter]').forEach(el => {
        el.textContent = label;
      });
    };

    const swiperConfig = {
      slidesPerView: isAutoWidth ? 'auto' : 1,
      spaceBetween: 16,
      loop: false,
      watchOverflow: true,
      navigation: {
        nextEl: `${sectionRoot} .equip-reasons-section-nav .swiper-button-next`,
        prevEl: `${sectionRoot} .equip-reasons-section-nav .swiper-button-prev`
      }
    };

    if (!isAutoWidth) {
      swiperConfig.breakpoints = {
        1024: {
          slidesPerView: totalSlides === 1 ? 1 : 2
        },
        1440: {
          slidesPerView: totalSlides === 1 ? 1 : 2
        },
        1920: {
          slidesPerView: totalSlides === 1 ? 1 : 2
        }
      };
    }

    const swiper = new Swiper(swiperEl, swiperConfig);

    const headerCounter = container.querySelector(
      '.equip-reasons-section__counter-header'
    );

    const alignCounterToLastCard = () => {
      if (!headerCounter) return;

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
      const lastSlide = slides[slides.length - 1];
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

      if (isDesktop && swiper.isLocked && lastSlide) {
        const gap =
          wrapper.getBoundingClientRect().right -
          lastSlide.getBoundingClientRect().right;
        headerCounter.style.marginInlineEnd = `${Math.max(0, Math.round(gap))}px`;
      } else {
        headerCounter.style.marginInlineEnd = '';
      }
    };

    updateCounter(swiper);
    requestAnimationFrame(alignCounterToLastCard);

    swiper.on('slideChange', () => {
      updateCounter(swiper);

      if (typeof calculateScrollPercentage === 'function') {
        calculateScrollPercentage(swiper, `${sectionRoot} h2`);
      }
    });

    swiper.on('breakpoint resize lock unlock', () => {
      updateCounter(swiper);
      alignCounterToLastCard();
    });
  });
});
